/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

const __vue_script__ = {
    name: 'CheckInStatus',

    components: {
        Badge
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        value: {
            type: Array,
            default: () => []
        },

        model: {
            type: Object,
            required: true
        },

        edit: {
            type: Boolean,
            default: false
        },

        options: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            expected: 0,
            checkedIn: 0,
            waiting: 0,
            checkedOut: 0
        };
    },

    computed: {
        isSessionPublic() {
            return !this.model.access_control && !this.model.targets;
        }
    },

    created() {
        if (this.edit) {
            this.calculateStats();
        }
    },

    methods: {
        async calculateStats() {
            try {
                const data = await this.$services.pax.getCheckInStatus(this.event.id, this.model._id);

                this.checkedIn = data.checked_in ? data.checked_in.length : 0;
                this.checkedOut = data.checked_out ? data.checked_out.length : 0;

                if (data.access_control && data.registered) {
                    this.expected = data.registered.length;
                    this.waiting = Math.max(this.expected - this.checkedIn, 0);
                } else if (data.targeted) {
                    this.expected = data.targeted.length;
                    this.waiting = Math.max(this.expected - this.checkedIn, 0);
                }

            } catch (error) {
                console.error('[CheckInStatus] Error calculating stats:', error.message);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.edit)?_c('control-decorator',{staticClass:"check-in-status",attrs:{"tip":_vm.tip,"uid":_vm.uid,"errors":_vm.errors,"warning":_vm.warning}},[(!_vm.isSessionPublic)?_c('div',{staticClass:"stat"},[_c('span',{staticClass:"check-in-stats-title"},[_vm._v(_vm._s(_vm.$t('agenda.check_in_status.expected_people')))]),_c('span',{staticClass:"badge info"},[_vm._v(_vm._s(_vm.expected))])]):_vm._e(),_c('div',{staticClass:"stat"},[_c('span',{staticClass:"check-in-stats-title"},[_vm._v(_vm._s(_vm.$t('agenda.check_in_status.checked_in_people')))]),_c('span',{staticClass:"badge info"},[_vm._v(_vm._s(_vm.checkedIn))])]),(!_vm.isSessionPublic)?_c('div',{staticClass:"stat"},[_c('span',{staticClass:"check-in-stats-title"},[_vm._v(_vm._s(_vm.$t('agenda.check_in_status.waiting_people')))]),_c('span',{staticClass:"badge info"},[_vm._v(_vm._s(_vm.waiting))])]):_vm._e(),_c('div',{staticClass:"stat"},[_c('span',{staticClass:"check-in-stats-title"},[_vm._v(_vm._s(_vm.$t('agenda.check_in_status.checked_out_people')))]),_c('span',{staticClass:"badge info"},[_vm._v(_vm._s(_vm.checkedOut))])])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CheckInStatus.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__